import router from "./index.js";
import store from "../store";
import { authRoutes } from "./auth.js";

// 动态路由
const allRoutes = {
  "e-project-list": {
    path: "e-project-list",
    name: "e-project-list",
    component: () => import("views/expertPages"),
  },
  "e-scoring": {
    path: "e-scoring",
    name: "e-scoring",
    component: () => import("views/expertPages/Score.vue"),
  },
  "p-project-list": {
    path: "p-project-list",
    name: "p-project-list",
    component: () => import("views/purchPages"),
  },
  survey: {
    path: "/survey",
    name: "survey",
    component: () => import("views/officePages/survey"),
  },
  matters: {
    path: "/matters",
    name: "matters",
    component: () => import("views/officePages/matters"),
  },
  declaration: {
    path: "/declaration",
    name: "declaration",
    component: () => import("views/officePages/agencyInfo/Declaration"),
  },
  "score-situation": {
    path: "/score-situation",
    name: "score-situation",
    component: () => import("views/officePages/score/Projects"),
  },
  "expert-evaluate": {
    path: "/expert-evaluate",
    name: "expert-evaluate",
    component: () => import("views/officePages/score/Experts"),
  },
  "a-project-list": {
    path: "a-project-list",
    name: "a-project-list",
    component: () => import("views/agency"),
  },
  "a-base-info": {
    path: "a-base-info",
    name: "a-base-info",
    component: () => import("views/agency/Info"),
  },
  "agency-info": {
    path: "agency-info",
    name: "agency-info",
    component: () => import("views/officePages/agencyInfo/BaseInfo"),
  },
  admin: {
    path: "admin",
    name: "admin",
    component: () => import("views/admin"),
  },
};

// 动态匹配路由
export function DynamicRoutes() {
  const { loginInfo } = store.state;

  if (loginInfo.roleId == undefined) return;
  if (loginInfo.roleId == 2) loginInfo.roleId = 3;

  for (let i of authRoutes[loginInfo.roleId]) {
    const temp = allRoutes[i];
    // 这个是官方提供的方法，动态的路由信息确实被记录了，但是是在vue tool里面却看不到被追加的路由信息
    router.addRoute("home", temp);
  }
  // router.options.routes[2].children.push(temp)
}
